import React from "react";
import { Grid, Typography, makeStyles, useMediaQuery } from "@material-ui/core";
import E_Alerts_Data from "./_data";
import E_PaginatationComponent from "./e_alerts_notification_pagination";
import { useSelector } from "react-redux";
import { Skeleton } from "@material-ui/lab";

const useStyle = makeStyles({
  gridContain: {
    height: "18rem",
  },
  smallGrid: {
    height: "15rem",
  },
  tabletGrid: {
    height: "19rem",
  },
  prepaidTabletGrid: {
    height: "16rem",
  },
  noContent: {
    marginTop: "5vh",
  },
});

export default function E_Card_Content({
  data,
  origin,
  displayPadding,
  noContent,
  totalPages,
  handlePageChange,
  page,
  autoOpenData,
  setAutoOpenData,
  noContentContentReady,setAnnLoad ,setMeterLoad,meterLoad,annLoad
}) {
  let classes = useStyle();
  const tablet = useMediaQuery("(min-height:1010px)");
  const browserName = useSelector((store) => store?.browserDetect?.browserName);
  return (
    <>
      {data && (
        <Grid container justify="center" alignContent="flex-start" >
          <Grid
            item
            xs={12}
            className={
              displayPadding
                ? tablet
                  ? classes.tabletGrid
                  : classes.gridContain
                : tablet
                ? classes.prepaidTabletGrid
                : classes.smallGrid
            }
            style={{overflowY: browserName === "firefox" ? "auto" : "overlay"}}
          >
            {data.length > 0 ? (
              data.map((item, k) => (
                <div key={k}>
                  <E_Alerts_Data
                    item={item}
                    displayPadding={displayPadding}
                    origin={origin}
                    page={page}
                    autoOpenData={autoOpenData}
                    setAutoOpenData={setAutoOpenData}
                  />
                </div>
              ))
            ) : (
              <Grid container justify="center">
                <Grid item>
                {
                  (meterLoad==false && annLoad==false) && noContentContentReady ?
                  <Typography variant="subtitle1" className={classes.noContent}>{noContent}</Typography>
                  : <Skeleton />
                }
                </Grid>
              </Grid>
            )}
          </Grid>

          {(origin === "LOWBALANCE" ||
            origin === "MINBALANCE" ||
            origin === "CHARGE") &&
            totalPages > 1 && (
              <Grid item>
                <E_PaginatationComponent
                  totalPagesCount={totalPages}
                  page={page}
                  handlePageChange={handlePageChange}
                />
              </Grid>
            )}
        </Grid>
      )}
    </>
  );
}
